import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { useCurrentSubscription } from '@/hooks/useSubscription'

/**
 * Global banner that displays when user's subscription is past_due.
 * Shows a prominent warning with link to update payment method.
 *
 * Fix for 6.90: past_due status should show a persistent warning banner
 */
export default function PastDueBanner() {
  const { data: subscription, isLoading } = useCurrentSubscription()

  // Don't show during loading or if no subscription or not past_due
  if (isLoading || !subscription || subscription.status !== 'past_due') {
    return null
  }

  return (
    /*
      `md:pl-[var(--app-rail)]` clears the sidebar, which is `fixed` from the
      header down. The variable is declared in index.css.
      These bars are not inside <main>, which is the element that clears it,
      so without this the left 12rem of the message is behind the nav. The
      padding goes on the outer band rather than the inner container because
      the inner one centres itself with `mx-auto`, and a left margin would
      fight that. ServiceStatusBanner already did this on its inner element.
    */
    <div className="bg-destructive text-destructive-foreground md:pl-[var(--app-rail)]">
      <div className="max-w-7xl mx-auto px-4 py-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 flex-shrink-0" />
            <span className="text-sm font-medium">
              Payment failed. Update your payment method to keep Pro access.
            </span>
          </div>
          <Link
            to="/settings/billing"
            className="text-sm font-semibold underline underline-offset-2 hover:no-underline whitespace-nowrap"
          >
            Update payment method &rarr;
          </Link>
        </div>
      </div>
    </div>
  )
}
